<template>
  <div class="HomePage">
    <el-container style="height: 100%">
      <el-header>
        <h4 style="cursor: pointer;display:flex;align-items:center" @click="$router.replace('/')">
          <a href="javascript:;">
            <span>Haleon 智能产品管理助手</span>
          </a>
        </h4>
        <div style="display: flex;align-items: center;cursor: pointer;" v-if="UserInfo">
          <el-dropdown @command="handleCommand">
            <span class="el-dropdown-link" style="display:flex;align-items:center">
              <img src="@/static/userAvator.png" alt="" srcset="">
              <span style="margin-left:5px;">{{UserInfo.username}}</span>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item icon="el-icon-back" command="out">退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div v-if="!UserInfo && !LoadingStatus">
          <el-button type="primary" class="addKeywordBtn" @click="LoginOut">登录</el-button>
        </div>
        <span v-if="LoadingStatus" v-loading="LoadingStatus"></span>
      </el-header>
      <el-container style="padding: 10px 0;">
        <el-aside>
          <!-- 左侧菜单 -->
          <el-menu :default-active="activeIndex" class="el-menu-vertical-demo" text-color="#999"
            active-text-color="#000" style="height: 100%;">
            <template v-for="(item, index) in MenuList">
              <el-menu-item :index="index + ''" class="firstChild" @click="handleOpen(item,index)">
                <span slot="title">{{ item.label }}</span>
              </el-menu-item>
            </template>
          </el-menu>
        </el-aside>
        <el-container>
          <el-main>
            <div class="view-box">
              <router-view></router-view>
            </div>
          </el-main>
        </el-container>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import api from '@/api'
import { getSSOAuthUrl } from '../utils/http'

export default {
  name: "MerchantAssistantHomePage",
  components: {},
  data() {
    return {
      activeIndex: '0',
      MenuList: [
        {
          label: "产品管理",
          path: '/ProductManagement'
        },
        {
          label: "物料管理",
          path: '/MaterialManagement'
        },
        {
          label: "店铺管理",
          path: '/StoreManagement'
        },
      ],
      UserInfo:'',
      LoadingStatus:false,
      ssoConfig: {
        enabled: true,
        ssoUrl: '',
        ssoSikp: 'false'
      }
    };
  },
  mounted() {
    this.initSSOConfig()
  },
  beforeDestroy() {
  },
  created() {
    this.getUserInfo()
  },
  methods: {
    // 初始化SSO配置并处理SSO认证
    async initSSOConfig() {
      this.LoadingStatus = true
      try {
        // 获取SSO配置
        const response = await api.getSSOConfig()
        if (response && response.data) {
          const config = response.data
          this.ssoConfig = {
            enabled: config.ssoSikp !== 'true',
            ssoUrl: config.ssoUrl,
            ssoSikp: config.ssoSikp
          }
          //console.log('SSO配置', this.ssoConfig)

          // 检查URL中是否有SSO返回的code并处理
          // 注意：自动跳转SSO的逻辑已经在路由守卫中处理，这里只处理返回的code
          this.checkSSOCode()
        }
      } catch (error) {
        console.error('获取SSO配置失败', error)
      } finally {
        this.LoadingStatus = false
      }
    },

    // 检查并处理SSO返回的code
    checkSSOCode() {
      const urlParams = new URLSearchParams(window.location.search)
      const ssoCode = urlParams.get('code')

      if (ssoCode) {
        this.LoadingStatus = true
        api.getSSOToken(ssoCode).then(res => {
          console.log('HomePage - SSO token响应:', res)
          if (res && res.access_token) {
            localStorage.setItem('token', res.access_token)
            
            // 保存用户角色（如果存在）
            if (res.user_role) {
              console.log('HomePage - 保存用户角色到localStorage:', res.user_role)
              localStorage.setItem('user_role', res.user_role)
              
              // 同时保存到Vuex store
              this.$store.dispatch('setUserRole', res.user_role)
              console.log('HomePage - 用户角色已保存到Vuex store:', res.user_role)
            } else {
              console.warn('HomePage - SSO返回结果中没有user_role字段')
            }
            
            // 清除URL中的code参数
            window.history.replaceState({}, document.title, '/')
            this.getUserInfo()
          } else {
            this.$message.error('SSO认证失败: ' + (res.detail || '无详细信息'))
          }
          this.LoadingStatus = false
        }).catch(e => {
          this.LoadingStatus = false
          
          // 【安全修复】处理403错误 - 用户不在数据库中
          if (e.response && e.response.status === 403) {
            console.error('用户未授权访问系统:', e.response.data)
            
            // 清除所有认证信息
            localStorage.removeItem('token')
            localStorage.removeItem('sso_access_token')
            localStorage.removeItem('sso_username')
            localStorage.removeItem('user_role')
            localStorage.removeItem('token_invalid')
            
            // 设置用户退出标记，防止再次自动跳转SSO
            localStorage.setItem('user_logged_out', 'true')
            
            // 清除URL中的code参数
            window.history.replaceState({}, document.title, '/')
            
            // 显示友好的错误提示
            const errorMessage = e.response.data && e.response.data.detail 
              ? e.response.data.detail 
              : '您的账号未授权访问此系统，请联系管理员'
            
            this.$message.error({
              message: errorMessage,
              duration: 10000,
              showClose: true
            })
            
            // 跳转到登录页
            this.$router.push('/login')
            return
          }
          
          // 其他错误的通用处理
          this.$message.error('SSO认证失败: ' + (e.message || '未知错误'))
        })
      }
      // 注意：如果没有code，不需要在这里处理，路由守卫会自动跳转SSO
    },

    // 跳转到SSO认证页面
    async redirectToSSO() {
      try {
        // 获取包含PKCE参数的SSO认证URL
        const authUrl = await getSSOAuthUrl()
        window.location.href = authUrl
      } catch (error) {
        console.error('获取SSO认证URL失败', error)
        this.$message.error('SSO认证配置获取失败')
      }
    },

    getUserInfo(){
      this.LoadingStatus = true
      api.getUserInfo(this.$BaseUrl()).then(res=>{
        this.UserInfo = res
        // 保存用户名到localStorage，以便在登录页面自动填充
        if (res && res.username) {
          localStorage.setItem('sso_username', res.username)
        }
        this.LoadingStatus = false
      }).catch(err => {
        console.error('获取用户信息失败:', err)
        this.LoadingStatus = false
      })
    },
    LoginOut() {
      // 设置退出登录标记，防止自动跳转SSO
      localStorage.setItem('user_logged_out', 'true')

      // 清除认证信息
      localStorage.removeItem('token')
      localStorage.removeItem('sso_access_token')
      localStorage.removeItem('sso_username')
      localStorage.removeItem('user_role')  // 清除用户角色
      sessionStorage.removeItem('pkce_code_verifier')
      localStorage.removeItem('pkce_code_verifier')

      // 跳转到登录页
      window.location.href = '/login'
    },
    handleOpen(item,index) {
      if(this.$route.path == item.path) return
      this.activeIndex = index + ''
      this.$router.push(item.path)
    },
    handleCommand(command) {
      if (command === 'out') {
        this.exitSystem()
      }
    },
    exitSystem() {
      this.$confirm('此操作将退出该系统, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        customClass: "exitConfirm"
      }).then(() => {
        // 设置退出登录标记，防止自动跳转SSO
        localStorage.setItem('user_logged_out', 'true')

        // 清除认证信息
        localStorage.removeItem('token')
        localStorage.removeItem('sso_access_token')
        localStorage.removeItem('sso_username')
        sessionStorage.removeItem('pkce_code_verifier')
        localStorage.removeItem('pkce_code_verifier')

        this.$message.success('操作成功！')
        setTimeout(() => {
          // 跳转到登录页
          window.location.href = '/login'
        }, 500)
      }).catch(() => { });
    }
  }
};
</script>

<style lang="less" scoped>
.HomePage {
  width: 100%;
  height: 100%;
  background-color: #f1f1f1;

  .el-footer {
    background-color: #fff;
    color: #333;
    text-align: center;
    line-height: 60px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .el-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 50px !important;
    z-index: 99;
    background-color: #fff;

    h4 {
      a {
        width: auto;
        height: 50px;
        text-decoration: none;
        color: #67C23A;
        line-height: 50px;
        text-align: center;
        font-size: 20px;
      }
    }

    img {
      width: 30px;
      height: 30px;
    }
  }

  .el-footer {
    font-size: 14px;

    a {
      text-decoration: none;
      color: #333;

      &:hover {
        color: #ff8629;
      }
    }
  }

  .el-aside {
    color: #333;
    text-align: left;
    width: 250px !important;
    position: relative;
    overflow: hidden;
    padding-left: 10px;
    ul {
      padding-top: 10px;
      li {
        margin-bottom: 10px;
        &:hover {
          background-color: #67C23A !important;

          span {
            color: #000 !important;
          }
        }
        &:focus {
          background-color: #67C23A !important;

          span {
            color: #000 !important;
          }
        }
      }
    }
  }

  .el-main {
    color: #333;
    padding: 0 10px !important;
    .view-box{
      height: calc(100vh - 70px);
      min-height: 800px;
      background-color: #fff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/HomePage.vue